import { createContext, useContext, useEffect, useState } from 'react';

const ViewModeContext = createContext();

export function ViewModeProvider({ children }) {
  const [mode, setMode] = useState(() => {
    return localStorage.getItem('view_mode') || 'auto';
  });

  useEffect(() => {
    localStorage.setItem('view_mode', mode);

    document.documentElement.classList.remove('force-mobile', 'force-desktop');
    if (mode === 'mobile') document.documentElement.classList.add('force-mobile');
    if (mode === 'desktop') document.documentElement.classList.add('force-desktop');
  }, [mode]);

  return (
    <ViewModeContext.Provider value={{ mode, setMode }}>
      {children}
    </ViewModeContext.Provider>
  );
}

export const useViewMode = () => useContext(ViewModeContext);